export default __webpack_public_path__ + "static/Gammeldansk-bg-e108ca50d8cd636ec10e5803683c3228.jpg";